export function explainIndependentScore(signal) {
  const counts=signal?.counts;
  if(!counts||!['CALL','PUT'].includes(signal.direcao)||
    !['verdes','vermelhas','cinzas'].every(key=>Number.isInteger(counts[key])&&counts[key]>=0))return null;
  const total=counts.verdes+counts.vermelhas+counts.cinzas;
  if(total!==15)return null;
  const aligned=counts[signal.direcao==='CALL'?'verdes':'vermelhas'];
  const consistency=aligned/total*100;
  const points=Number.isFinite(signal.score_raw)?signal.score_raw:signal.confirmacao;
  if(!Number.isFinite(points)||Math.abs(points-(consistency+5))>0.011)return null;
  return {total,aligned,counts,consistency,points,bonus:5,color:signal.direcao==='CALL'?'verdes':'vermelhas'};
}
